import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { UseConsultationQuestionsResponse } from './useConsultationQuestions.types';

const PREFIX = '[consultationSummaryQuery]';

export const queryConsultationQuestions = async (consultationId: number) => {
  console.log(PREFIX, `Fetching consultation #${consultationId}...`);
  const response = await CONSULTATIONS_ENDPOINTS.consultationQuestions(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultation #${consultationId}.`);
  return json as UseConsultationQuestionsResponse[];
};
